import { render } from "./compare-plan.vue?vue&type=template&id=31350b96&scoped=true"
import script from "./compare-plan.vue?vue&type=script&lang=js"
export * from "./compare-plan.vue?vue&type=script&lang=js"

import "./compare-plan.vue?vue&type=style&index=0&id=31350b96&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3414373455/src/platform-insurance-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31350b96"]])

export default __exports__